
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { BillingPlan } from '@/types/billing';
import { toast } from '@/hooks/use-toast';

export const useBillingPlans = () => {
  const [billingPlans, setBillingPlans] = useState<BillingPlan[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('billing_plans')
        .select('*')
        .order('price', { ascending: true });
      
      if (error) throw error;
      
      // Process the data to ensure features is a proper Record<string, boolean>
      const processedData = data?.map(plan => ({
        ...plan,
        // Ensure features is handled properly
        features: plan.features || {}
      })) as BillingPlan[];
      
      setBillingPlans(processedData || []);
    } catch (error: any) {
      console.error('Erreur lors du chargement des forfaits:', error);
      toast({
        title: "Erreur",
        description: "Impossible de charger les forfaits disponibles.",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  // Get plans on component mount
  useEffect(() => {
    fetchPlans();
  }, []);

  return {
    billingPlans,
    loading,
    refetch: fetchPlans
  };
};
